<template>
  <v-container fluid>
    <v-card elevation="1">
      <v-toolbar color="secondary" dark shaped>
        <h3 class="title">{{ $route.name }}</h3>
        <v-spacer />
        <v-tooltip bottom color="primary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              dark
              v-bind="attrs"
              v-on="on"
              to="/supplies-manager/create"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Adicionar</span>
        </v-tooltip>
        <v-tooltip bottom color="secondary">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              dark
              v-bind="attrs"
              v-on="on"
              @click="showSearch = !showSearch"
            >
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <span>Pesquisar</span>
        </v-tooltip>
        <v-tooltip bottom color="yellow darken-3">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon dark v-bind="attrs" v-on="on" @click="initialize">
              <v-icon>mdi-update</v-icon>
            </v-btn>
          </template>
          <span>Atualizar</span>
        </v-tooltip>
        <v-footer absolute color="primary" dark v-if="showSearch">
          <v-text-field
            class="search-field"
            v-model="search"
            color="#fff"
            placeholder="pesquisar"
            prepend-inner-icon="mdi-magnify"
            append-outer-icon="mdi-close"
            @click:append-outer="showSearch = !showSearch"
          />
        </v-footer>
      </v-toolbar>

      <v-card-actions>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          :items-per-page="8"
          :loading="loader"
          loading-text="CARREGANDO..."
          class="elevation-0 maxPage"
        >
          <template v-slot:item.supply_code="{ item }">
            <span>{{
              item.supply_code ? item.supply_code : item.vehicle_password
            }}</span>
          </template>

          <template v-slot:item.model_desc="{ item }">
            <span
              >{{ item.brand_desc }} - {{ item.model_desc }} -
              {{ item.vehicle_board }}</span
            >
          </template>
          <template v-slot:item.datehour="{ item }">
            <span>{{ convertDateTime(item.datehour) }}</span>
          </template>
          <template v-slot:item.supply_ajusted="{ item }">
            <span>{{ item.supply_ajusted ? "SIM" : "NÃO" }}</span>
          </template>
          <template v-slot:item.supply_billed="{ item }">
            <span>{{ item.supply_billed ? "FATURADO" : "NÃO" }}</span>
          </template>
          <template v-slot:item.supply_liters_stocked="{ item }">
            <span>{{
              item.supply_liters_stocked
                ? realMaskII(item.supply_liters_stocked.toFixed(3))
                : 0
            }}</span>
          </template>

          <template v-slot:item.action="{ item }">
            <v-tooltip bottom color="purple">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="mr-2"
                  @click="
                    [(showPassword = true), (password = item.supply_code)]
                  "
                  color="purple"
                  >mdi-eye</v-icon
                >
              </template>
              <span>Ver Senha</span>
            </v-tooltip>
            <v-tooltip
              bottom
              color="primary"
              v-if="item.supply_status != 'CONCLUIDO'"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="mr-2"
                  @click="
                    $router.push(`/supplies-manager/edit/${item.supply_id}`)
                  "
                  color="primary"
                  >mdi-pencil</v-icon
                >
              </template>
              <span>Editar</span>
            </v-tooltip>
            <v-tooltip bottom color="success">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  small
                  class="mr-2"
                  @click="openModal(item.supply_id)"
                  color="success"
                  >mdi-square-edit-outline</v-icon
                >
              </template>
              <span>Corrigir</span>
            </v-tooltip>
            <v-tooltip bottom color="error">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="deleteItem(item.user_id)"
                  color="error"
                  >mdi-delete</v-icon
                >
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="headline grey lighten-2"
          >Alterar Abastecimento</v-card-title
        >
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-mask="'00/00/0000 00:00'"
                  v-model="dataAdjust.datehour"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  label="Veículo:"
                  :items="vehicles"
                  item-value="vehicle_id"
                  v-model="dataAdjust.vehicle_id"
                >
                  <template slot="selection" slot-scope="{ item }"
                    >{{ item.brand_desc }} - {{ item.model_desc }} -
                    {{ item.vehicle_board }}</template
                  >
                  <template slot="item" slot-scope="{ item }"
                    >{{ item.brand_desc }} - {{ item.model_desc }} -
                    {{ item.vehicle_board }}</template
                  >
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="12" md="12">
                <v-autocomplete
                  label="Item:"
                  :rules="fieldRules"
                  :items="items"
                  item-value="item_id"
                  item-text="item_description_desc"
                  v-model="dataAdjust.item_id"
                >
                  <template slot="selection" slot-scope="{ item }"
                    >{{ item.item_description_desc }} preço R$:
                    {{
                      item.item_price ? realMask(item.item_price.toFixed(0)) : 0
                    }}</template
                  >
                  <template slot="item" slot-scope="{ item }"
                    >{{ item.item_description_desc }} preço R$:
                    {{
                      item.item_price ? realMask(item.item_price.toFixed(0)) : 0
                    }}</template
                  >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  label="Litros Abastecidos:"
                  v-model="dataAdjust.supply_liters_stocked"
                  v-mask-decimal.br="3"
                  @change="calculateSubTotals"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  label="Preço do Dia:"
                  v-model="dataAdjust.supply_price_day"
                  v-mask-decimal.br="3"
                  @change="calculateSubTotals"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  disabled
                  label="Valor:"
                  v-model="dataAdjust.supply_value"
                  v-mask-decimal.br="2"
                />
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  label="Cupom:"
                  v-model="dataAdjust.supply_coupon"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="error" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" :loading="loader" text @click="ajust"
            >Confirmar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showPassword" width="300">
      <v-card>
        <v-card-title class="headline primary lighten-2 text-center"
          >COPIE SUA SENHA</v-card-title
        >
        <v-card-text class="mt-6 text-center">
          <v-row>
            <v-col cols="12" sm="12">
              <v-label>
                <input
                  readonly
                  class="text-h4 text-center"
                  style="width: 100%; border: 0; outline: none"
                  ref="copiar"
                  :value="password"
                />
              </v-label>
            </v-col>
            <v-col cols="12" sm="12">
              <v-btn
                :color="copiado ? 'green' : 'primary'"
                depressed
                :dark="copiado"
                block
                @click="copy"
                :outlined="!copiado"
              >
                <v-icon v-if="copiado">mdi-check</v-icon>
                {{ copiado ? "COPIADO" : "COPIAR" }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
export default {
  mixins: [Helpers],
  data() {
    return {
      search: "",
      loader: true,
      copiado: false,
      password: "",
      showPassword: false,
      showSearch: false,
      dialog: false,
      data: [],
      providers: [],
      items: [],
      vehicles: [],
      fieldRules: [(v) => !!v || "Este campo é requerido"],
      prefecture_id: null,
      snack: {
        show: false,
        message: "",
        color: "",
      },
      dataAdjust: {
        supply_id: null,
        vehicle_id: null,
        provider_id: null,
        item_id: null,
        supply_liters_stocked: 0,
        supply_price_day: 0,
        supply_coupon: null,
        supply_value: 0,
      },
      headers: [
        {
          text: "Data/Hora",
          value: "datehour",
          sortable: false,
          align: "left",
        },
        { text: "Setor", value: "sec_name", sortable: false, align: "left" },
        { text: "Veículo", value: "model_desc", sortable: false },
        {
          text: "Item",
          value: "item_description_desc",
          sortable: false,
          align: "left",
        },
        {
          text: "Total de Litros",
          value: "supply_liters_stocked",
          sortable: false,
          align: "left",
        },
        {
          text: "Cupom",
          value: "supply_coupon",
          sortable: false,
          align: "left",
        },
        {
          text: "Status",
          value: "supply_status",
          sortable: false,
          align: "left",
        },
        {
          text: "Corrigido",
          value: "supply_ajusted",
          sortable: false,
          align: "left",
        },
        {
          text: "Faturado",
          value: "supply_billed",
          sortable: false,
          align: "left",
        },
        { text: "Ações", align: "right", value: "action", sortable: false },
      ],
    };
  },
  created() {
    this.Helpers;
    this.prefecture_id = this.$store.getters.getUserData.table_id;
    this.initialize();
  },
  methods: {
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/supplies/${this.prefecture_id}`)
        .then((r) => {
          this.data = r.data;
          this.loader = false;
          this.snack.color = "success";
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    copy() {
      var copyTextarea = this.$refs.copiar;
      copyTextarea.select();
      try {
        var successful = document.execCommand("copy");
        if (successful) {
          this.copiado = true;
          setTimeout(() => {
            this.showPassword = false;
            this.copiado = false;
          }, 1000);
        } else {
          alert("não copiado!");
        }
      } catch (err) {
        alert(
          "Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C."
        );
      }
    },
    ajust() {
      delete this.dataAdjust.supply_authorized_liters;
      delete this.dataAdjust.supply_authorized_value;
      this.dataAdjust.supply_adjusted = true;
      this.$http
        .put(`/supplies/single/${this.dataAdjust.supply_id}`, this.dataAdjust)
        .then((r) => {
          this.snack.show = true;
          this.snack.message = r.data.result;
          this.loader = true;
          setTimeout(() => {
            this.dialog = false;
            this.initialize();
          }, 1500);
        })
        .catch((e) => {
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        });
    },
    openModal(id) {
      this.$http.get(`/supplies/single/${id}`).then((r) => {
        this.dataAdjust = r.data[0];
        this.dataAdjust.supply_liters_stocked = r.data[0].supply_liters_stocked.toFixed(
          3
        );
        this.dataAdjust.supply_price_day = r.data[0].supply_price_day.toFixed(
          3
        );
        this.dataAdjust.datehour = this.convertDateTime(r.data[0].datehour);
        this.$http.get(`/vehicles/supplies/${this.prefecture_id}`).then((v) => {
          this.vehicles = v.data;
          this.$http
            .get(`/supplies/providers/${r.data[0].provider_id}`)
            .then((i) => {
              this.items = i.data;
              this.dialog = true;
            });
        });
      });
    },
    calculateSubTotals() {
      if (
        this.dataAdjust.supply_liters_stocked &&
        this.dataAdjust.supply_price_day
      ) {
        let subtotal =
          this.convertDecimalNumberII(this.dataAdjust.supply_price_day) *
          this.convertDecimalNumberII(this.dataAdjust.supply_liters_stocked);
        this.dataAdjust.supply_value = subtotal.toFixed(2);
      }
    },
    deleteItem(id) {
      let c = confirm("Deseja excluir o registro?");
      if (c) {
        this.$store.dispatch("setLoader", true);
        this.$http
          .delete(`/supplies/${id}`)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.initialize();
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style scoped>
.top-bar {
  padding: 30px 15px;
}
.title {
  text-transform: uppercase;
  font-weight: 400;
}
.maxPage {
  width: 100%;
}
.search-field {
  margin-top: 10px;
}
.space {
  margin: 0 10px;
}
</style>